module.exports = __webpack_public_path__ + "img/works_kbstar_btm_off_m.71c64273.jpg";